import { getUUIDFromURL } from '../getUUIDFromURL/getUUIDFromURL'

export const getCompanyUUID = () => {
    return getUUIDFromURL() || sessionStorage.getItem('companyUUID') || undefined
}
